import { render } from "./PortfolioContent.vue?vue&type=template&id=3d899e60&scoped=true"
import script from "./PortfolioContent.vue?vue&type=script&lang=js"
export * from "./PortfolioContent.vue?vue&type=script&lang=js"

import "./PortfolioContent.vue?vue&type=style&index=0&id=3d899e60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d899e60"

export default script